function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import CareLocaleKeys from '../../../../../../locales/keys';
import { CurrentAddressesSelector } from '../../../../../../reducers/selectors/customer.addresses.selectors';
import { updateCustomizedServiceTax } from '../../../../../../reducers/actions/services.actions';
import { CurrentCustomerIdSelector } from '../../../../../../reducers/selectors/customer.selectors';
import { IsUpdatingServiceTaxSelector } from '../../../../../../reducers/selectors/services.selectors';
var ServiceTaxCustomizationDetailsController = /*#__PURE__*/function () {
  function ServiceTaxCustomizationDetailsController($ngRedux, $timeout, uiNotificationService) {
    var _this = this;
    _classCallCheck(this, ServiceTaxCustomizationDetailsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CareLocaleKeys: CareLocaleKeys,
      closeEditServiceTaxCustomization: this.closeEditServiceTaxCustomization.bind(this),
      moreMenuItems: [{
        title: i18n.translate(CareLocaleKeys.EDIT),
        action: function action() {
          _this.openEditServiceTaxCustomization();
        }
      }],
      onMoreMenuItemSelected: this.onMoreMenuItemSelected.bind(this),
      onSave: this.onSave.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ServiceTaxCustomizationDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var controllerActions = {
        updateCustomizedServiceTax: updateCustomizedServiceTax
      };
      var mapStateToProps = function mapStateToProps(state) {
        return {
          currentAddresses: CurrentAddressesSelector(state),
          currentCustomerId: CurrentCustomerIdSelector(state),
          isUpdatingServiceTax: IsUpdatingServiceTaxSelector(state)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      this.editServiceTaxPopUpConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.editServiceTaxPopupApi = event.api;
        }
      };
    }
  }, {
    key: "onMoreMenuItemSelected",
    value: function onMoreMenuItemSelected(_ref) {
      var itemAction = _ref.item;
      itemAction.action();
    }
  }, {
    key: "openEditServiceTaxCustomization",
    value: function openEditServiceTaxCustomization() {
      this.showEditServiceTaxPopup = true;
      this.$timeout(this.editServiceTaxPopupApi.open);
    }
  }, {
    key: "closeEditServiceTaxCustomization",
    value: function closeEditServiceTaxCustomization() {
      this.showEditServiceTaxPopup = false;
      this.editServiceTaxPopupApi.close();
    }
  }, {
    key: "onSave",
    value: function onSave(customTax) {
      var _this3 = this;
      this.actions.updateCustomizedServiceTax(customTax, this.state.currentCustomerId).then(function () {
        _this3.closeEditServiceTaxCustomization();
        return _this3.fetchService()();
      }).catch(function (error) {
        _this3.closeEditServiceTaxCustomization();
        _this3.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }]);
}();
export default {
  bindings: {
    serviceTaxDetails: '<',
    openEditServiceTaxView: '&?',
    fetchService: '&'
  },
  template: require('./service.tax.customization.details.template.html'),
  controller: ServiceTaxCustomizationDetailsController,
  controllerAs: 'ServiceTaxCustomizationDetailsController'
};